var exports = {
  "o": "xe533113f--dbb196--tooltip-box",
  "Y": "xe533113f--dbb196--tooltip-icon",
};

module.exports = exports;
